<template>
  <CreateScheduleModal :date="selectedDate"/>
  <UpdateScheduleModal />
   <div class="row">
      <div class="col-xxxl-12">
        <div class="card mb-25 border-0 rounded-0 bg-white calendar-card">
          <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing">

            <div class="header-left-side justify-content-center justify-content-md-start d-flex align-items-center col-12 col-md-12 col-sm-12 col-lg-4 col-xl-4 col-xxl-4 mb-15">
              <select 
                v-if="getUsers.length" 
                v-model="selectedUser" 
                @change="onOperationChange" 
                class="form-select shadow-none text-black fs-md-15"
              >
                <option disabled value="">Selecione um usuário</option>
                <option value="*">Todos os usuários</option>
                <option v-for="user in getUsers"
                        :key="user.id"
                        :value="user.id">
                  {{ user.name }}
                </option>
              </select>
            </div>

            <FullCalendar :options="calendarOptions" />
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">

import * as bootstrap from 'bootstrap';
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex"; 
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
const STORAGE_KEY = 'selected_user_id';
import CreateScheduleModal from './CreateScheduleModal.vue';
import UpdateScheduleModal from './UpdateScheduleModal.vue';

export default defineComponent({
  name: "CalendarPage",
  components: {
    FullCalendar ,
    CreateScheduleModal,
    UpdateScheduleModal
  },
  data() {
    return {
      selectedUser: "",
      selectedDate: "",
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        locale: 'pt-br',

        selectable: true,
        editable: true,

        dayCellClassNames: (arg) => {
          const today = new Date();
          today.setHours(0,0,0,0);

          const cellDate = new Date(arg.date);
          cellDate.setHours(0,0,0,0);

          if (cellDate < today) {
            return ['fc-day-disabled'];
          }

          return [];
        },

        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },

        buttonText: {
          today: 'Hoje',
          month: 'Mês',
          week: 'Semana',
          day: 'Dia'
        },

        events: [{}],

        dateClick: this.handleDateClick,
        eventClick: this.handleEventClick,
        datesSet: this.searchSchedules
      }
    }
  },
  mounted() {

    const params = {
      user_id: "*",
      year: new Date().getFullYear(),
      month: String(new Date().getMonth() + 1).padStart(2, '0')
    };

    this.fetchUsers(null).then(() => {
      if(localStorage.getItem(STORAGE_KEY)){
        this.selectedUser = localStorage.getItem(STORAGE_KEY) || "";
        params.user_id = this.selectedUser;
      }

      this.fetchCalendar(params);
    });

    this.fetchCategories();
  },
  watch: {
    getCalendar(newVal) {
      if(Array.isArray(newVal)){
        newVal.forEach(element => {
          const serviceTitle = element.service && element.service.name ? element.service.name : element.status && element.status == 'BLOCKED' ? 'Bloqueio' : 'Sem título';
          const clientName = element.client && element.client.name ? element.client.name : null;

          element.title = clientName ? `${serviceTitle} - ${clientName}` : serviceTitle;
          element.start = element.date + " " + element.start_time_service;
          element.end = element.date + " " + element.end_time_service;

          // color blocked slots differently
          if (element.status === 'BLOCKED') {
            // fullcalendar accepts `color` or `backgroundColor`
            element.color = '#ef4444';
          } else {
            // optionally enforce default blue or clear previous value
            element.color = '#3b82f6';
          }
        });

        this.calendarOptions.events = newVal;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCalendar",
      "getUsers"
    ])
  },
  methods: {
    ...mapActions([
      "fetchCalendar",
      "fetchCategories",
      "fetchUsers",
      "setCurrentCalendar"
    ]),
    searchSchedules(info) {
      // fullcalendar view.activeStart pode começar no último dia da semana anterior ao mês atual
      // currentDate reflete o mês/semana/dia atualmente exibido pelo calendário
      const date = info.view.currentDate || info.view.currentStart || info.view.activeStart;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');

      const params = {
        user_id: this.selectedUser || "*",
        year,
        month
      };

      this.fetchCalendar(params);
    },
    handleDateClick(info) {
      // const title = prompt('Nome do evento')

      // if (title) {
      //   this.calendarOptions.events.push({
      //     title,
      //     start: info.dateStr
      //   })
      // }


      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const clickedDate = new Date(info.dateStr + 'T00:00:00');

      // bloqueia datas passadas
      if (clickedDate < today) {
        return;
      }

        // guarda a data se quiser usar depois
      this.selectedDate = info.dateStr;

      // abre o modal do Bootstrap
      const modalEl = document.getElementById('createScheduleModal');

      if (modalEl) {
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }
    },

    handleEventClick(info) {
      // alert(`Evento: ${info.event.title}`)

      const data = {...info.event.extendedProps, id: info.event.id, date: info.event.startStr.split('T')[0]};
      this.setCurrentCalendar(data);

      const modalEl = document.getElementById('updateScheduleModal');

      if (modalEl) {
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }
    },

    onOperationChange() {
      const ops = this.getUsers || [];

      const isValid = this.selectedUser &&
                      ops.some((op) => String(op.id) === String(this.selectedUser));

      if (isValid || this.selectedUser === "*") {
        localStorage.setItem(STORAGE_KEY, this.selectedUser);
        window.location.reload();
      } else {
        localStorage.removeItem(STORAGE_KEY);
        this.selectedUser = "";
        alert("Usuário inválido, selecione novamente.");
      }
    }
  }
});
</script>
